<div class="color-square">
    <div
        *ngFor="let color of colors"
        (click)="select(color)"
        [ngClass]="{'active': color==colorSelected, 'inactive': color!=colorSelected}"
        [style.background-color]="color"
    >&nbsp;</div>
</div>
